export default "__VITE_ASSET__d483bd00__"